<main>
  <div class="container">

    <div class="row mb-4">
      <div class="col general-title">
        <h2>Histórico de Fundos</h2>
      </div>
    </div>

    <div class="filters pt-2 pt-lg-4 pl-2 pl-lg-4 pb-3 pb-lg-5">
      <div class="row w-100" [formGroup]="formFiltro">
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_inicio">De</label>
          <select name="data_inicio" id="data_inicio" formControlName="anomesInicio">
            <option value="0">Data Inicio</option>
            @for (inicio of anoMesInicio; track inicio) {
              <option value="{{inicio.ANOMES}}">{{inicio.ANOMES_FORMATADO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_fim">Até</label>
          <select name="data_fim" id="data_fim" formControlName="anomesFim">
            <option value="0">Data Fim</option>
            @for (fim of anoMesFim; track fim) {
              <option value="{{fim.ANOMES}}">{{fim.ANOMES_FORMATADO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <select name="tipo_contrib" id="tipo_contrib" formControlName="tipoFundo">
            <option selected disabled value="0">Tipo de Fundos</option>
            @for (tipo of tiposFundos; track tipo) {
              <option value="{{tipo.COD_FUNDO}}">{{tipo.DCR_FUNDO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-auto mb-2 mb-lg-0">
          <select name="ordernar" id="ordernar" formControlName="tipoOrdem">
            <option selected disabled value="0">Ordenar por</option>
            <option value="1">Data</option>
            <option value="2">Valor</option>
          </select>
        </div>
        <div class="col-auto divbtnFiltro">
          <a style="color: white;cursor:pointer" class="btn btn-success" (click)="Listar()"><i class="fa fa-filter" aria-hidden="true"></i> Filtrar</a>
        </div>
        <div class="col-auto divbtnExportar">
          <a class="btn btn-extract" (click)="print()"><i class="fa fa-print"></i> Emitir Extrato</a>
        </div>
      </div>
    </div>

    <div class="box table-responsive mb-4">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th>Data de Referência</th>
            <th>Tipo de Fundo</th>
            <th>Saldo Anterior</th>
            <th>Entrada</th>
            <th>Saída</th>
            <th>Rentabilidade</th>
            <th>Saldo Atual</th>
          </tr>
        </thead>
        <tbody>
          @for (item of fundos | paginate: { itemsPerPage: qntPorPage, currentPage: paginaAtual }; track item) {
            <tr>
              <td class="date">{{item.DCR_ANOMES}}</td>
              <td>{{item.DCR_FUNDO}}</td>
              <td>{{item.SLD_ANTERIOR | currency:"R$"}}</td>
              <td>{{item.VLR_ENT_MES | currency : "R$"}}</td>
              <td>{{item.SLD_SAI | currency : "R$"}}</td>
              <td>{{item.VLR_RENT_MES | number}}</td>
              <td>{{item.SLD_FINAL | currency : "R$"}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="col-md-12  text-right">
      <pagination-controls (pageChange)="paginaAtual = $event" previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
    </div>

  </div>
</main>


